import { render, staticRenderFns } from "./DeviceHistoryListView.vue?vue&type=template&id=d13a80da&"
import script from "./DeviceHistoryListView.vue?vue&type=script&lang=ts&"
export * from "./DeviceHistoryListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports